import React from "react"
import PropTypes from "prop-types"
import { X } from "lucide-react"
import {
  CardHeader,
  CardTitle,
  CardContent,
  Button,
  CardFooter,
  CardDescription,
} from "ksc-portal-common-components/shadcn"

const CodeExpired = (props) => {
  const {
    forgotPassword,
    searchObject: { username },
    backToLogin,
  } = props
  return (
    <>
      <CardHeader className="flex flex-col items-center gap-4">
        <Button
          onClick={backToLogin}
          variant="ghost"
          size="icon"
          className="absolute right-3 top-3 rounded-full"
          aria-label="Close"
          data-testid="back-button"
        >
          <X className="h-4 w-4" />
        </Button>
        <svg
          width="66"
          height="66"
          viewBox="0 0 66 66"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="Illustrations">
            <circle
              id="Ellipse 85"
              cx="33"
              cy="33"
              r="32"
              fill="#D1D5DB"
              stroke="#9BA3AF"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle
              id="Ellipse 84"
              cx="33.001"
              cy="33"
              r="24.96"
              fill="#F7FAFB"
              stroke="#9BA3AF"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              id="Vector (Stroke)"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.988 18C34.6383 18 35.9761 19.3638 35.9761 21.0462V35.2059C35.9761 36.8883 34.6383 38.2521 32.988 38.2521C31.3378 38.2521 30 36.8883 30 35.2059V21.0462C30 19.3638 31.3378 18 32.988 18ZM30 44.9538C30 43.2714 31.3378 41.9076 32.988 41.9076H33.012C34.6622 41.9076 36 43.2714 36 44.9538C36 46.6362 34.6622 48 33.012 48H32.988C31.3378 48 30 46.6362 30 44.9538Z"
              fill="#B30009"
            />
          </g>
        </svg>
      </CardHeader>
      <CardContent className="flex flex-col items-center space-y-2">
        <CardTitle className="text-2xl font-medium text-center text-foreground">
          Code Expired
        </CardTitle>
        <CardDescription className="text-center text-sm text-muted-foreground">
          Your password code has expired. Would you like us to send a new code?
        </CardDescription>
      </CardContent>
      <CardFooter className="flex justify-center">
        <Button
          variant="default"
          onClick={() => forgotPassword(username)}
          className="w-full"
        >
          Send New Code
        </Button>
      </CardFooter>
    </>
  )
}

CodeExpired.propTypes = {
  forgotPassword: PropTypes.func.isRequired,
  searchObject: PropTypes.shape({ username: PropTypes.string }).isRequired,
  backToLogin: PropTypes.func.isRequired,
}

export default CodeExpired
